export default "__VITE_ASSET__sXqike8P__"